export const selectIsReportSending = (state) => state.report.isReportSending;
